import React from 'react'
import FacebookLogin, {
  ReactFacebookFailureResponse,
  ReactFacebookLoginInfo
  // @ts-ignore Typings are not included for the "render prop" build
} from 'react-facebook-login/dist/facebook-login-render-props'
import {
  useRegisterCustomerMutation,
  OAuthType,
  AuthenticatedUserFragment
} from '#src/generated/graphql'
import FacebookIconMark from './facebook-iconmark.svg'
import config from '#src/config'
import classnames from 'classnames'
import styles from './styles.css'

interface FacebookOAuthButtonProps {
  className?: string
  wrapperClassName?: string
  referralCodeId?: string | null
  onSuccess: (user: AuthenticatedUserFragment) => void
  onFailure: (error: string) => void
}

const FacebookOAuthButton: React.SFC<FacebookOAuthButtonProps> = ({
  className,
  wrapperClassName,
  referralCodeId,
  onSuccess,
  onFailure,
  ...rest
}) => {
  const [registerCustomer] = useRegisterCustomerMutation()

  /**
   * After successfully completing the Facebook OAuth flow, submit the ID token to our API
   *   for authentication.
   */
  const handleSuccess = (response: ReactFacebookLoginInfo) => {
    registerCustomer({
      variables: {
        input: {
          firstName: response.first_name,
          lastName: response.last_name,
          email: response.email,
          externalOAuthType: OAuthType.FACEBOOK,
          externalOAuthToken: response.accessToken,
          referralCodeId
        }
      }
    }).then(response => {
      const errors = response.errors

      // Handle failures at the GraphQL level
      if (errors) {
        onFailure('Facebook authentication failed!')
        return
      }

      const payload = response.data!.registerCustomer

      if (payload.user) {
        onSuccess(payload.user)
      } else {
        onFailure(
          (payload.errors && payload.errors.join('\n')) || 'Facebook authentication failed!'
        )
      }
    })
  }

  /**
   * Handle failures from the Facebook OAuth flow itself.
   */
  const handleFailure = (response: ReactFacebookFailureResponse) => {
    switch (response.status) {
      // TODO: What are the valid response statuses?
      default:
        onFailure('Facebook authentication failed!')
    }
  }

  return (
    <FacebookLogin
      appId={config.get('facebook.app_id')}
      scope="public_profile,email"
      fields="first_name,last_name,email"
      disableMobileRedirect={true}
      callback={handleSuccess}
      onFailure={handleFailure}
      render={(props: {
        onClick: () => void
        isDisabled: boolean
        isProcessing: boolean
        isSdkLoaded: boolean
      }) => {
        return (
          <div className={classnames(styles.wrapper, wrapperClassName)} onClick={props.onClick}>
            <div className={classnames(styles.button, className)}>
              <FacebookIconMark className={styles.logo} /> Continue with Facebook
            </div>
          </div>
        )
      }}
      {...rest}
    />
  )
}

export default FacebookOAuthButton
